<template>
  <div class="good-item">
    <div style="">
      <div class="good-img">
        <router-link :to="'/tourist/goodsDetails?id='+msg.id">
          <img :src="getImgPath(msg.productPic)" :alt="msg.productName">
        </router-link>
      </div>
      <h6 class="good-title" v-html="msg.productName">{{msg.productName}}</h6>
      <h3 class="sub-title ellipsis">{{msg.brandName}}</h3>
      <div class="good-price pr">
        <div class="ds pa">
          <router-link :to="'/tourist/goodsDetails?id='+msg.id">
            <y-button text="查看详情"></y-button>
          </router-link>
          <y-button text="加购物车"
                    @btnClick="addCart(msg.id,msg.salesPrice,msg.productName,msg.productPic)"
                    classStyle="main-btn"
          ></y-button>
        </div>
        <p><span style="font-size: 16px">￥</span>
          {{msg.salesPrice}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '../YButton/YButton'
  import { mapMutations, mapState } from 'vuex'
  import {getCookie} from '@/utils/support';
  import { createCart } from '@/api/cart'
  import good404 from '@/assets/images/good_404.png'

  export default {
    props: {
      msg: {}
    },
    data () {
      return {}
    },
    computed: {
      ...mapState(['userLogin', 'showMoveImg', 'showCart'])
    },
    methods: {
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      goodsDetails (id) {
        this.$router.push({path: '/tourist/goodsDetails/id=' + id})
      },
      getImgPath (url) {
        if (url === undefined || url === null || url === '') {
          return good404
        }
        return process.env.BASE_API + '/home/img'+ url;
      },
      addCart (id, price, name, img) {
        if (!this.showMoveImg) {     // 动画是否在运动
          if (this.userLogin) { // 登录了 直接存在用户名下
            createCart({
              username: getCookie('username'),
              pid: id,
              quantity: 1,
              productPrice: price,
              productPic: img,
              productName: name,
              checked: '1'
            }).then(res => {
              // 并不重新请求数据
              this.ADD_CART({productId: id, salesPrice: price, productName: name, productImg: img})
            })
          } else { // 未登录 vuex
            this.ADD_CART({productId: id, salesPrice: price, productName: name, productImg: img})
          }
          // 加入购物车动画
          let dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: img})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
        }
      }
    },
    mounted () {
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../assets/style/mixin";
  @import "../../assets/style/theme";

  .good-item {
    background: #fff;
    width: 25%;
    transition: all .5s;
    height: 430px;
    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .good-price p {
        display: none;
      }
      .ds {
        display: flex;
      }
    }
    .ds {
      @extend %block-center;
      width: 100%;
      display: none;
    }

    .good-img {
      img {
        margin: 50px auto 10px;
        @include wh(206px);
        display: block;
      }
    }
    .good-price {
      margin: 15px 0;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #e4393c;
      font-size: 20px;
    }
    .good-title {
      line-height: 1.2;
      font-size: 16px;
      color: #424242;
      margin: 0 auto;
      padding: 0 14px;
      text-align: center;
      overflow: hidden;
    }
    h3 {
      text-align: center;
      line-height: 1.2;
      font-size: 12px;
      color: #d0d0d0;
      padding: 10px;
    }
  }

  @media screen and (max-width: 500px) {
    .good-item {
      background: #fff;
      width: 33%;
      transition: all .5s;
      height: 180px;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 1px 1px 20px #999;

        .good-price p {
          display: none;
        }

        .ds {
          display: flex;
        }
      }

      .ds {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        display: none;
      }

      .good-img {
        img {
          margin: 10px auto 5px;
          width: 100px;
          height: 100px;
          display: block;
        }
      }

      .good-price {
        margin: 1px 0;
        height: 10px;
        text-align: center;
        line-height: 10px;
        color: #e4393c;
        font-size: 14px;
      }

      .good-title {
        line-height: 1.2;
        font-size: 8px;
        color: #424242;
        margin: 0 auto;
        padding: 0 1px;
        text-align: center;
        overflow: hidden;
      }

      h3 {
        text-align: center;
        line-height: 1.2;
        font-size: 6px;
        color: #d0d0d0;
        padding: 1px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MallGoods/mallGoods.vue